import type { Ref } from 'react';
import { faSpinner } from '@awesome.me/kit-4a6bf60416/icons/classic/regular';

import { Icon } from '@/components/ui/icon';
import { MutedText } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

interface LoadMoreSentinelProps {
  sentinelRef: Ref<HTMLDivElement | null>;
  isLoadingMore: boolean;
  hasNextPage: boolean;
  className?: string;
}

export function LoadMoreSentinel({
  sentinelRef,
  isLoadingMore,
  hasNextPage,
  className,
}: LoadMoreSentinelProps) {
  if (!hasNextPage) return null;

  return (
    <div ref={sentinelRef} className={cn('flex items-center justify-center py-8', className)}>
      {isLoadingMore && (
        <MutedText className="flex items-center gap-2">
          <Icon icon={faSpinner} className="size-4 animate-spin" />
          Loading more...
        </MutedText>
      )}
    </div>
  );
}
